import _ from 'lodash';
import { selectors as cacheSelectors } from '../reducers/Cache';
import { selectors as configSelectors } from '../reducers/Configuration';
import {
  ShotFormatter,
  type ShotUnitType,
} from 'innovatint_base/common/formatters/ShotFormatter';
import { LEVEL_UNITS } from 'js/Constants';
import { equalsIgnoreCase } from '../../mylib/Utils';
import type { Unit } from 'js/api/types/Cache';
import type { RootState } from '../reducers';

type FormatterState = Pick<RootState, 'cache' | 'configurations'>;

type ShotFormatterFactory = (unitname?: string | null | Unit) => ShotFormatter;

function asShotUnit(
  unit: Unit | ShotUnitType | undefined
): ShotUnitType | undefined {
  return unit as ShotUnitType | undefined;
}

/**
 * High order function to create formatters for formula display.
 * @param {*} state Redux root state
 * @returns function that creates ShotFormatter from unit name
 */
export function createShotFormatter(
  state: FormatterState
): ShotFormatterFactory {
  const {
    formula_display_unit,
    priceoption_decimal_separator,
    priceoption_trailing_zeros,
  } = configSelectors.config_values(state);

  return (unitname) => {
    const unit = cacheSelectors.getUnit(
      state,
      typeof unitname === 'string' || unitname == null
        ? unitname || (formula_display_unit as string | undefined)
        : unitname.unitname
    );
    return new ShotFormatter(
      asShotUnit(unit),
      priceoption_decimal_separator as string | undefined,
      Boolean(priceoption_trailing_zeros)
    );
  };
}

/**
 * High order function to create formatters for canister levels and custom cans.
 * @param {*} state Redux root state
 * @returns function that creates ShotFormatter from unit name
 */
export function createLevelFormatter(
  state: FormatterState
): ShotFormatterFactory {
  const { level_display_unit, priceoption_decimal_separator } =
    configSelectors.config_values(state);

  return (unitname) => {
    const u =
      typeof unitname === 'string' || unitname == null
        ? unitname || (level_display_unit as string | undefined)
        : unitname.unitname;
    const unit =
      _.find(LEVEL_UNITS, (x) =>
        equalsIgnoreCase(x.unitname, u as string | null | undefined)
      ) || LEVEL_UNITS[0];
    return new ShotFormatter(
      asShotUnit(unit),
      priceoption_decimal_separator as string | undefined
    );
  };
}
